/**
 * @author Muhammad Omran
 * @copyright Copyright 2019 by Radivision Inc., CA, USA. All Rights Reserved.
 * @Date: 2020-01-28
 * @description Implementation of the GraphQL query to retrieve the Upcoming show.
 * @filename poster-query.tsx
 */
import { graphql, GraphQLTaggedNode } from "react-relay";

/**
 * The GraphQL query to retrieve the current user.
 *
 * @type {GraphQLTaggedNode}
 */
export const POSTER_QUERY: GraphQLTaggedNode = graphql`
  query posterQuery($id: ID!) {
    poster(id: $id) {
      errors {
        created
        id
        location
        type
      }
      hasErrors
      poster {
        __typename
        id
        description
        permalink
        actionTitle
        previews {
          count
          edges {
            cursor
            preview {
              link
              kind
              mediaAsset {
                id
                files {
                  id
                  name
                  path
                }
                topLevelMediaType {
                  kind
                  label
                }
              }
            }
          }
        }
        publishedDate
        rating {
          values {
            count
            rating
          }
        }
        revision
        subTitle
        summary
        title
      }
    }
  }
`;
